<script setup>
	function govHeaderDropdown() {
		const content = document.getElementById('gov-dropdown-content');
		const caret = document.getElementsByTagName("i");
		if(content.classList.contains("show")) {
			content.classList.remove("show");
			if(caret) {
			caret[0].style.transform = "rotate(0deg)";
			}
		} else {
			content.classList.add("show");
			if(caret) {
			caret[0].style.transform = "rotate(180deg)";
			}    
		}
	}
</script>

<template> 
<div id="gov-header">
	<div>
		<img alt="USA flag" class="logo" src="@/assets/images/usa-flag.png" width="16" height="11" />
	</div>
	<div class="gov-menu">
	An official website of the United States government 
	<button class="btn-link-gov collapsible" @click="govHeaderDropdown()">Here's how you know
		<i class="fa-solid fa-xs fa-chevron-down"></i></button>        
	</div>
</div>
<div id="gov-dropdown-content">
	<div class="grid-cols">
		<img alt="Government site" src="@/assets/images/icon-dot-gov.svg" class="gov-icon" />
		<div>
			<b>Official websites use .gov</b><br>
			A .gov website belongs to an official government organization
			in the United States.
		</div>
	</div>
	<div class="grid-cols">
		<img alt="Secure site" src="@/assets/images/icon-https.svg" class="gov-icon" />
		<div>
			<b>Secure .gov websites use HTTPS.</b><br>
			A lock (
			<span class="icon-lock">
				<svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 52 64" 
				class="usa-banner__lock-image" role="img" aria-labelledby="banner-lock-description" focusable="false">
				<title id="banner-lock-title-default">Lock</title><desc id="banner-lock-description">Locked padlock</desc><path 
				fill="#ffffff" fill-rule="evenodd" d="M26 0c10.493 0 19 8.507 19 19v9h3a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V32a4 4 0 0 1 4-4h3v-9C7 8.507 15.507 0 26 0zm0 8c-5.979 0-10.843 4.77-10.996 10.712L15 19v9h22v-9c0-6.075-4.925-11-11-11z"></path>
				</svg>
			</span>	
			) or https:// means you've safely connected to the
			.gov website. Share sensitive information only on official, secure websites.
		</div>
	</div>    
</div> 
</template>

<style scoped>
	#gov-header {
		display: flex;
		width: 100%;
		padding: 0 2rem;
		align-content: center;
		justify-content:start;  
		background-color:#162e51;
		min-height: 1.75rem;
		border-top-left-radius: var(--radius-xl);
		border-top-right-radius: var(--radius-xl);  
	}

	#gov-header .gov-menu {
		margin-left: 1rem;
		color: #FFF;
		font-family: "Open Sans", "Segoe UI", Roboto, Helvetica, Arial;
		font-size: 0.75rem;
		font-style: normal;
		font-weight: 500;
		line-height: 1.625rem;
		ZZmin-height: 1.75rem;
	}

	#gov-header .btn-link-gov {
		color: #73b3e7;
		background-color:#162e51;;
		border: none;
		text-align: left;
		outline: none;  
		text-decoration: underline;
		font-size: .75rem;
		padding: 0 0 0 var(--spacing-xl, 1.5rem);
		height: 1.625rem;
		min-height: unset;
	}

	/* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
	#gov-header .collapsible:hover {
		color: #73b3e7;
	}

	#gov-header i {
		color: #73b3e7;
	}		

	/* Style the collapsible content. Note: hidden by default */
	#gov-dropdown-content {
		overflow: hidden;
		background:#162e51;
		width: 100%;
		min-height: 0;
		height: 0;
		transition: min-height .2s linear;
		color: #FFF;
		font-family: "Open Sans", "Segoe UI", Roboto, Helvetica, Arial;
		font-size: 1rem;
		ZZbox-sizing: border-box;
		column-gap: .5rem;
	}

	#gov-dropdown-content.show{
		height: unset;
		display: flex;
		flex-direction: row;
		justify-content: center;  
		padding: .5rem;
	}

	#gov-dropdown-content .gov-icon {
		width: 2.5rem;
	}

	#gov-dropdown-content .grid-cols {
		display:flex;
		flex-direction: columns;
		justify-items: flex-end;
		align-items: start;
		padding-top: .5rem;
		gap: 10px;
		max-width: 37.5rem;;
	}

	/* 767px - mobile */
	@media (max-width: 47.9375rem) {
		#gov-header {
			border-radius: 0;
			padding-left: .5rem;
			padding-right:.5rem;
		}
		#gov-header .btn-link-gov {
			padding-left: .125rem;
		}
	}

	/* 1023px */
	@media only screen and (max-width: 63.9375rem) {
		#gov-dropdown-content.show{
			display: block;
		}
	}
</style>

